import React from "react";
import { Container } from "./styled/label";

function Label(props) {
  return <Container {...props} />;
}

export default Label;
